// Cart drawer upsell variant dropdowns - updated 2026-08-19
//
// Uses one delegated listener on document instead of binding to each select on
// DOMContentLoaded. Adding an item to the cart replaces the contents of
// .drawer__inner, and script tags inserted via innerHTML do not re-execute, so
// directly-bound listeners were lost after the first cart update. That matters
// now that upsells backfill: the product that moves up into an empty slot is
// freshly rendered markup.

document.addEventListener('change', function (event) {
	const selectElement = event.target.closest(
		'.drawer__upsell-product-variants'
	)
	if (!selectElement) return

	const selectedProd = selectElement.closest('.drawer__upsell-product')
	if (!selectedProd) return

	const variantId = selectElement.value
	const selectedOption = selectedProd.querySelector(
		`.drawer__upsell-product-option[value="${variantId}"]`
	)
	if (!selectedOption) return

	const variantInput = selectedProd.querySelector('[name="id"]')
	if (variantInput) variantInput.setAttribute('value', variantId)

	const newImage = selectedOption.getAttribute('data-image')
	const imageElem = selectedProd.querySelector('.drawer__upsell-image')
	if (imageElem && newImage) imageElem.setAttribute('src', newImage)

	const newPrice = selectedOption.getAttribute('data-price')
	const newComparePrice = selectedOption.getAttribute('data-compare-price')

	const regularPriceElem = selectedProd.querySelector('.price-item--regular')
	const comparePriceElem = selectedProd.querySelector(
		'.price-item--compare-at-price'
	)
	const salePriceElem = selectedProd.querySelector('.price-item--sale')

	// The compare-at and sale prices carry a visually hidden "Regular price" /
	// "Sale price" label for screen readers (added 2026-10-19). Writing the price
	// with innerText would wipe it, so the label is rebuilt with each price. Label
	// text comes from data attributes rendered with the theme's translations.
	const labels =
		selectedProd.querySelector('.drawer__upsell-product-price')?.dataset || {}
	const setPrice = (elem, price, label) => {
		if (!elem) return
		elem.textContent = ''
		if (!price) return
		if (label) {
			const hidden = document.createElement('span')
			hidden.className = 'visually-hidden'
			hidden.textContent = label + ' '
			elem.appendChild(hidden)
		}
		elem.appendChild(document.createTextNode(price))
	}

	if (!newComparePrice) {
		setPrice(regularPriceElem, newPrice)
		setPrice(comparePriceElem, '')
		setPrice(salePriceElem, '')
	} else {
		setPrice(regularPriceElem, '')
		setPrice(comparePriceElem, newComparePrice, labels.labelRegular)
		setPrice(salePriceElem, newPrice, labels.labelSale)
	}
})
